<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>
        <FormulateForm
            class="company-profile-form"
            v-model="companyData"
            @submit="updateProfile"
        >
            <FormulateInput
                name="name"
                type="text"
                label="Company Name"
                help="Company name as used in normal trading"
                :placeholder="loading ? '' : 'Company Name'"
                validation="required"
                validation-name="Company Name"
                :disabled="loading"
                :disable-errors="loading"
                :outer-class="['formulate-horizontal']"
            />
            <hr>
            <FormulateInput
                name="full_legal_name"
                type="text"
                label="Full Legal Name"
                help="Full legal name of the company as shown on registration documents"
                :placeholder="loading ? '' : 'Full Legal Name'"
                validation="required"
                validation-name="Full Legal Name"
                :disabled="loading"
                :disable-errors="loading"
                :outer-class="['formulate-horizontal']"
            />
            <hr>
            <FormulateInput
                name="website"
                type="url"
                label="Website"
                help="Starting with http://..."
                :placeholder="loading ? '' : 'http://www...'"
                validation="required|url"
                validation-name="Website"
                :disabled="loading"
                :disable-errors="loading"
                :outer-class="['formulate-horizontal']"
            />
            <FormulateInput
                type="submit"
                :disabled="loading"
            >
                <b-spinner small v-if="loading" class="mr-2"></b-spinner>
                <span>{{ loading ? 'Loading' : 'Update Profile' }}</span>
            </FormulateInput>
        </FormulateForm>
        <!-- <pre>{{ companyData }}</pre> -->
    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import merge from 'lodash/merge';

export default {
    name: 'CompanyPortalProfileUpdate',
    components: {},
    props: {
        
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: true,
            companyData: {},
        }
    },
    computed: {

    },
    mounted: function() {
        this.getProfileData();
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        setLocalData: function(apiData) {
            // set local companyData object from the structure returned from API
            // API data may be nested if you use nested serializers, so un-nest here
            this.companyData = merge({}, apiData);  // TODO - not needed anymore?
        },
        getProfileData: function() {
            this.loading = true;
            return suppliosApi.portal.getCompanyProfile()
                .then(response => {
                    this.companyData = response.data;
                    //this.setLocalData(response.data);
                    return true;
                })
                .catch(err => {
                    this.handleError(err, 'Error while getting profile data');
                    return false;
                })
                .then(success => {
                    this.loading = false;
                    return success;
                })
        },
        updateProfile: function(data) {
            this.loading = true;
            return suppliosApi.portal.updateCompanyProfile(data)
                .then(response => {
                    this.companyData = response.data;
                    this.$toast.success('Successfully updated company profile.');
                    return true;
                })
                .catch(err => {
                    this.handleError(err, 'Error while updating profile data');
                    return false;
                })
                .then(success => {
                    this.loading = false;
                    return success;
                })
        }

    }
}
</script>

<style>

</style>